import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack?',
  a: 'Te llega automáticamente luego del pago con acceso inmediato para descargar.'
}, {
  q: '¿Necesito experiencia para usarlo?',
  a: 'No. Todo está listo para imprimir y aplicar.'
}, {
  q: '¿Sirve para trabajar en casa?',
  a: 'Sí. Está pensado tanto para aula como para hogar.'
}, {
  q: '¿Los materiales son imprimibles?',
  a: 'Sí, podés imprimir todo las veces que quieras.'
}, {
  q: '¿Funciona para TEA y TDAH?',
  a: 'Sí. Incluye recursos adaptados y visuales para distintas necesidades.'
}, {
  q: '¿Tengo acceso inmediato?',
  a: 'Sí. Comprás y accedés automáticamente.'
}, {
  q: '¿Los bonos están incluidos?',
  a: 'Sí. Los 6 bonos vienen sin costo extra.'
}, {
  q: '¿Está pensado para Argentina?',
  a: 'Sí. El lenguaje y formato están adaptados al contexto argentino.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-[#FFF1E6] py-16 sm:py-24 px-4" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <h2 className="text-3xl sm:text-4xl font-black text-[#3D3935] mb-4" data-id="element-38">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#8B7E76] font-medium text-base sm:text-lg" data-id="element-39">
            Todo lo que necesitás saber antes de empezar.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-40">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`bg-white border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-[#F5C84B] shadow-sm' : 'border-[#EFE3D4]'}`} data-id="element-41">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 sm:p-6 text-left" data-id="element-42">
                  <span className="text-[#3D3935] font-black text-sm sm:text-base pr-4" data-id="element-43">
                    {faq.q}
                  </span>
                  <span className={`text-xl transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#F5A04B]' : 'text-[#8B7E76]'}`} data-id="element-44">
                    ↓
                  </span>
                </button>
                <AnimatePresence data-id="element-45">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-46">
                      <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-[#8B7E76] font-medium text-sm sm:text-base" data-id="element-47">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}